import React, { useCallback } from 'react';
import styled from 'styled-components';

import NotificationBtn from '@template/Notifications/NotificationBtn';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import ChatBtn from '@pages/Chat/ChatBtn';
import MusicButton from '@template/MusicPlayer/MusicBtn';
import LoginUserSec from '@components/navigation/common/LoginUserSec';
import { useRecoilValue } from 'recoil';
import { layoutTypeState } from '@atom/setting/homepageSet';
import { LAYOUT_TYPE } from '@typings/setting/layoutType';
import { useNavigate } from 'react-router-dom';
import Icon from '@components/dataDisplay/Icons/Icon';
import Tooltip from '@components/dataDisplay/Tooltip';
import IconButton from '@components/dataEntry/button/IconButton';

const BtnWrap = styled.div`
  position: fixed;
  top: 32px;
  right: 100px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: fit-content;
  z-index: 4;

  @media (max-width: 480px) {
    top: 56px;
    left: 6px;
  }
`;

const FrontBtnWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;

  @media (max-width: 480px) {
    padding: 6px 12px;
  }
`;

function CharacterFuncSec() {
  const layoutType = useRecoilValue(layoutTypeState);
  const navigate = useNavigate();

  const handleHomeClick = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <BtnWrap>
      <FrontBtnWrap>
        {layoutType === LAYOUT_TYPE.GAMEUI && (
          <IconButton
            icon="Home14"
            onClick={handleHomeClick}
            tooltip="홈으로"
            tooltipDir="bottom"
            shape="default"
          />
        )}
        <MusicButton color="var(--menuTextColor)" />
        <NotificationBtn dropdownDir="topRight" color="var(--menuTextColor)" />
        {masterSet.chat && <ChatBtn color="var(--menuTextColor)" />}
        <LoginUserSec />
      </FrontBtnWrap>
    </BtnWrap>
  );
}

export default CharacterFuncSec;
